module.exports = __webpack_public_path__ + "videos/optimised/84ccfdd71d4ac1de80996dc984b01fb0.mp4";